import React, {useEffect, useState} from "react";
import _ from 'underscore';
import useLocations from "../hooks/useLocations";
import MyDropDown from "../utility/myDropDown";
import t from '../../../helpers/t';
import usePricetariffs from "../hooks/usePricetariffs";
import {Biscuit} from "../../../../utils";

const uuid = _.uniqueId;

const LocationsDropDown = ({ currentCity, setCurrentCity, select }) => {

  const { resultLocation, handleChangeLocation } = useLocations({
      currentCity,
      setCurrentCity,
      select
  });



  const [location,setLocation] = useState(null);
  const [ldInitialized,setLdInitialized] = useState(false);
    const useUsageTypes = (Biscuit.get('client.show_usage_types') === 'true');
      if (resultLocation.citiesReducer.length > 0 && !ldInitialized && ((select === 'location' && useUsageTypes) || select === 'set')) {
          if(typeof window.__temp_filter_location_id !== 'undefined')
          {
              // Once set (i.e. display) location passed as URI-parameter
              setCurrentCity(Number(window.__temp_filter_location_id));
              // caution: you can't remove the url filter immediately because setCurrentCity is not directly executed but a bit later during re-render
              // deleting the filter is done inside of the click handler (bugfix [#25066])
              //delete window.__temp_filter_location_id;
              setLocation(Number(window.__temp_filter_location_id));
          } else {

              if((select === 'location' && useUsageTypes) || select === 'set') {
                  setCurrentCity(Number(resultLocation.citiesReducer[0].id));
                  setLocation(Number(resultLocation.citiesReducer[0].id));
              }
              // handleChangeLocation({value:Number(resultLocation.citiesReducer[0].id)})
              setLdInitialized(true);
          }
      }


    useEffect(() => {
        if(location !== null && ldInitialized){
            handleChangeLocation({value:location});
            setLocation(null);
        }
    },[location])

  return (
    <ul className="inb-vert-list">
      <span className="inb-list-title">
          {t('location',null,'capital')}
      </span>
      {resultLocation.citiesReducer.length > 0  && (
        <MyDropDown
          className="adjust"
          controlClassName="noBorders-noBackground"
          key={uuid()}
          options={resultLocation.citiesReducer.map((city, i) => {
            return { value: city.id, label: city.name, arrayId: i };
          })}
          onChange={handleChangeLocation}
          value={
            currentCity === ""
              ? ""
              : resultLocation.citiesReducer.filter(city => city.id === currentCity)[0]
                  .name
          }
          placeholder={t('select_${a}',{a:t('location')})}
          type={'location'}
          setInit={setLdInitialized}
        />
      )}
    </ul>
  );
};

export default LocationsDropDown;
